import { render, staticRenderFns } from "./YpoEventsResult.vue?vue&type=template&id=247747fe&scoped=true&"
import script from "./YpoEventsResult.vue?vue&type=script&lang=js&"
export * from "./YpoEventsResult.vue?vue&type=script&lang=js&"
import style0 from "./YpoEventsResult.vue?vue&type=style&index=0&id=247747fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247747fe",
  null
  
)

export default component.exports